// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .pq-create-page {
  background: #f8fafc;
  min-height: 100vh;
  padding: 0;
  color: #0f172a;
  font-family: "Roboto", sans-serif;
}

.pq-create-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin: 18px;
  margin-bottom: 0;
  padding: 22px 24px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
}

.pq-create-title {
  margin: 0;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 700;
  color: #0f172a;
}

.pq-create-subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  color: #64748b;
}

.pq-top-cancel-btn,
.pq-footer-cancel-btn {
  height: 40px;
  padding: 0 18px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #1e293b;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pq-top-cancel-btn:hover,
.pq-footer-cancel-btn:hover {
  background: #f8fafc;
}

.pq-footer-primary-btn {
  height: 42px;
  padding: 0 20px;
  border: 0;
  background: #2563eb;
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pq-footer-primary-btn:hover {
  background: #1d4ed8;
}

.pq-footer-primary-btn:disabled,
.pq-top-cancel-btn:disabled,
.pq-footer-cancel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pq-create-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 18px;
  align-items: start;
  padding: 16px 18px 24px;
}

.pq-create-left,
.pq-create-right {
  min-width: 0;
}

.pq-create-card,
.pq-workflow-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
}

/* Allow react-select menus (Assign Designer) to extend past the card edge; workflow card stays clipped */
.pq-workflow-card {
  overflow: hidden;
}

.pq-create-card {
  overflow: visible;
}

.pq-create-card-body {
  padding: 22px;
}

.pq-form-group + .pq-form-group {
  margin-top: 22px;
}

.pq-form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #111827;
}

.pq-light-text {
  color: #94a3b8;
  font-weight: 500;
}

.pq-helper-text {
  margin: 8px 0 0;
  font-size: 12px;
  color: #94a3b8;
}

.pq-text-input,
.pq-textarea-input,
.pq-select-like,
.pq-designer-group .css-13cymwt-control,
.pq-designer-group .css-t3ipsp-control {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #111827;
  font-size: 14px;
}

.pq-text-input {
  height: 42px;
  padding: 0 14px;
}

.pq-textarea-input {
  min-height: 140px;
  padding: 14px 16px;
  resize: vertical;
  line-height: 1.6;
}

.pq-text-input::placeholder,
.pq-textarea-input::placeholder {
  color: #94a3b8;
}

.pq-text-input:focus,
.pq-textarea-input:focus,
.pq-select-like:focus {
  outline: none;
  border-color: #93c5fd;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
}

.pq-search-holder {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pq-add-agent-btn {
  height: 42px;
  padding: 0 16px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #1d4ed8;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.pq-add-agent-btn:hover {
  background: #dbeafe;
}

.pq-agent-details-card,
.pq-add-agent-form-wrap {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
}

/* Address autocomplete dropdown must escape card clipping. */
.pq-add-agent-form-wrap {
  overflow: visible;
}

/* Inline team member form inside project create (not a modal) */
.brokerage-teammember-creation-inline {
  width: 100%;
  padding: 0 18px 18px;
}

.brokerage-teammember-creation-inline .content.container {
  max-width: none;
  padding: 0;
}

.brokerage-teammember-creation-embedded {
  padding: 1rem 1.25rem 1.5rem;
}

.pq-address-autocomplete-menu {
  z-index: 2147483647 !important;
}

/* .pq-agent-card-head,
.pq-add-agent-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px;
  border-bottom: 1px solid #e5e7eb;
} */

.pq-agent-card-head h3,
.pq-add-agent-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
}

.pq-add-agent-subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  color: #64748b;
}

.pq-agent-edit-btn,
.pq-add-agent-close {
  height: 40px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.pq-add-agent-close {
  width: 40px;
  justify-content: center;
  padding: 0;
}

.pq-agent-grid-details,
.pq-agent-grid-compact {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  padding: 18px;
}

/* .pq-k {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 6px;
} */

.pq-v {
  font-size: 14px;
  color: #111827;
  line-height: 1.6;
  word-break: break-word;
}

.pq-add-agent-section {
  border-top: 1px solid #e5e7eb;
}

.pq-add-agent-section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  font-size: 18px;
  font-weight: 700;
  color: #334155;
}

.pq-add-agent-section-head .orange {
  color: #f97316;
}

.pq-add-agent-section-head .green {
  color: #22c55e;
}

.pq-add-agent-section-head .purple {
  color: #a855f7;
}

.pq-add-agent-section-head .pink {
  color: #ec4899;
}

.pq-add-agent-grid-1,
.pq-add-agent-grid-2,
.pq-add-agent-grid-3 {
  display: grid;
  gap: 18px;
  padding: 0 18px 18px;
}

.pq-add-agent-grid-1 {
  grid-template-columns: 1fr;
}

.pq-add-agent-grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.pq-add-agent-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

/* Add-agent flow: react-select menu stays column width; long firm names wrap */
.pq-add-agent-select-cell {
  min-width: 0;
}

.pq-add-agent-react-select {
  width: 100%;
}

.pq-add-agent-rs__control,
.pq-add-agent-rs__control--is-focused {
  width: 100%;
  min-height: 44px;
  border: 1px solid #c8d0dc;
  border-radius: 10px;
  box-shadow: none;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
}

.pq-add-agent-rs__menu {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

/* Body portaled menu — above modals/cards (overflow:hidden cannot clip it) */
.pq-add-agent-rs__menu-portal {
  z-index: 10050;
}

.pq-add-agent-rs__option {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  line-height: 1.35;
}

.pq-select-wrap {
  position: relative;
}

.pq-select-wrap select {
  appearance: none;
  width: 100%;
  height: 42px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #111827;
  padding: 0 40px 0 14px;
  font-size: 14px;
}

.pq-select-wrap i {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  pointer-events: none;
}

.pq-upload-box {
  border: 2px dashed #d1d5db;
  border-radius: 14px;
  background: #f8fafc;
  text-align: center;
  padding: 42px 20px;
  transition: 0.2s ease;
}

.pq-upload-box--drag {
  border-color: #60a5fa;
  background: #eff6ff;
}

.pq-upload-box-icon {
  font-size: 46px;
  color: #9ca3af;
  margin-bottom: 10px;
}

.pq-upload-box-title {
  font-size: 15px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 4px;
}

.pq-upload-box-or {
  color: #94a3b8;
  font-size: 14px;
  margin-bottom: 14px;
}

.pq-upload-box-btn {
  height: 38px;
  padding: 0 16px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #1e293b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pq-upload-box-note {
  margin-top: 12px;
  font-size: 12px;
  color: #94a3b8;
}

.pq-uploaded-files {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.pq-uploaded-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 12px;
  padding: 12px;
}

.pq-uploaded-file-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pq-uploaded-file-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f1f5f9;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-uploaded-file-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  word-break: break-word;
}

.pq-uploaded-file-remove {
  width: 34px;
  height: 34px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  color: #ef4444;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pq-designer-group {
  position: relative;
  z-index: 40;
  max-width: 340px;
}

.pq-designer-rs__menu {
  z-index: 50;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

.pq-message-card {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: visible;
  background: #fff;
}

.pq-message-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.pq-emoji-inline-btn {
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pq-message-emoji-wrap {
  position: relative;
  flex-shrink: 0;
}

/* Portaled to document.body — fixed so it floats over the textarea (not in layout flow). */
.pq-message-emoji-pop {
  position: fixed;
  z-index: 10050;
  min-width: 280px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.14);
}

.pq-message-emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
}

.pq-message-emoji-item {
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 22px;
  line-height: 1.2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  transition: background 0.12s ease;
}

.pq-message-emoji-item:hover {
  background: #f1f5f9;
}

.pq-message-textarea {
  width: 100%;
  min-height: 110px;
  padding: 14px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  resize: vertical;
  font-size: 14px;
  line-height: 1.6;
}

.pq-message-check {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  font-size: 14px;
  color: #334155;
}

.pq-conversation-disabled {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.pq-conversation-scroll {
  max-height: 320px;
  overflow-y: auto;
  padding: 14px;
  background: #fff;
}

.pq-conversation-footer-note {
  padding: 14px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
  font-size: 13px;
  color: #64748b;
  text-align: center;
}

.pq-bottom-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #e5e7eb;
}

.pq-workflow-card-head {
  padding: 16px 18px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.pq-workflow-card-body {
  padding: 18px;
}

.pq-workflow-list-wrap {
  position: relative;
}

.pq-workflow-row {
  position: relative;
  display: flex;
  gap: 12px;
  padding-bottom: 22px;
}

.pq-workflow-left {
  position: relative;
  width: 32px;
  flex-shrink: 0;
}
/* 
.pq-workflow-line {
  position: absolute;
  left: 15px;
  top: 34px;
  bottom: -10px;
  width: 2px;
  background: #d1d5db;
} */

.pq-workflow-icon {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  position: relative;
  z-index: 1;
}

.pq-workflow-icon.blue {
  background: #dbeafe;
  color: #2563eb;
}

.pq-workflow-icon.purple {
  background: #f3e8ff;
  color: #9333ea;
}

.pq-workflow-icon.green {
  background: #dcfce7;
  color: #16a34a;
}

.pq-workflow-icon.orange {
  background: #ffedd5;
  color: #ea580c;
}

.pq-workflow-icon.mint {
  background: #dcfce7;
  color: #059669;
}

.pq-workflow-content {
  padding-top: 2px;
}

.pq-workflow-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
}

.pq-workflow-detail,
.pq-workflow-assigned {
  font-size: 14px;
  line-height: 1.5;
  color: #64748b;
}

.pq-edit-status-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  padding: 16px 18px;
}

.pq-edit-status-top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.pq-edit-status-icon {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: #dcfce7;
  color: #059669;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.pq-edit-status-icon.inprogress {
  background: #ede9fe;
  color: #7c3aed;
}

.pq-edit-status-icon.quoted {
  background: #ffedd5;
  color: #ea580c;
}

.pq-edit-status-icon.approved {
  background: #dcfce7;
  color: #16a34a;
}

.pq-edit-status-icon.completed {
  background: #d1fae5;
  color: #059669;
}

.pq-edit-status-badge {
  height: 30px;
  padding: 0 14px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}

.pq-edit-status-badge.inprogress {
  background: #cffafe;
  color: #0e7490;
}

.pq-edit-status-badge.quoted {
  background: #ffedd5;
  color: #c2410c;
}

.pq-edit-status-badge.approved {
  background: #d1fae5;
  color: #15803d;
}

.pq-edit-status-badge.completed {
  background: #e5e7eb;
  color: #374151;
}

.pq-edit-status-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
}

.pq-edit-status-text {
  font-size: 14px;
  color: #64748b;
}

@media (max-width: 1200px) {
  .pq-create-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .pq-create-header {
    flex-direction: column;
    align-items: stretch;
    padding: 18px;
  }

  .pq-create-layout {
    padding: 14px 0 20px;
  }

  .pq-create-card-body,
  .pq-workflow-card-body {
    padding: 18px;
  }

  .pq-agent-grid-details,
  .pq-agent-grid-compact,
  .pq-add-agent-grid-2,
  .pq-add-agent-grid-3 {
    grid-template-columns: 1fr;
  }

  .pq-message-label-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .pq-bottom-actions {
    flex-direction: column;
  }

  .pq-footer-cancel-btn,
  .pq-footer-primary-btn,
  .pq-top-cancel-btn,
  .pq-text-input,
  .pq-designer-group {
    width: 100%;
    max-width: 100%;
  }

  .pq-add-agent-title {
    font-size: 28px;
  }
}

.search-bat-card{
  margin-bottom: 21px;
}

.pq-create-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 clamp(16px, 3vw, 40px) 28px;
  min-height: 100vh;
  /* background: #f3f4f6; */
  color: #111827;
  font-family: "Roboto", sans-serif;
}

.pq-create-page *,
.pq-create-page *::before,
.pq-create-page *::after {
  box-sizing: border-box;
}

.pq-create-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  background: #ffffff;
  border-bottom: 1px solid #d9dee7;
}

.pq-create-title {
  margin: 0;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 500;
  color: #111827;
}

.pq-create-subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.45;
  color: #4b5563;
}

.pq-top-cancel-btn,
.pq-footer-cancel-btn {
  min-width: 88px;
  height: 40px;
  padding: 0 18px;
  border: 1px solid #c7ced8;
  border-radius: 10px;
  background: #ffffff;
  color: #1f2937;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.pq-top-cancel-btn:hover,
.pq-footer-cancel-btn:hover {
  background: #f9fafb;
  border-color: #b6c0cd;
}

.pq-footer-primary-btn {
  min-width: 136px;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #2563eb;
  border-radius: 10px;
  background: #2563eb;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.pq-footer-primary-btn:hover {
  background: #1d4ed8;
}

.pq-footer-primary-btn:disabled,
.pq-top-cancel-btn:disabled,
.pq-footer-cancel-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.pq-create-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 510px;
  gap: 24px;
  align-items: start;
  padding: 24px 0 28px;
}

.pq-create-left,
.pq-create-right {
  min-width: 0;
}

.pq-create-right {
  position: sticky;
  top: 24px;
  align-self: start;
}

.pq-create-card,
.pq-workflow-card,
.pq-agent-details-card,
.pq-add-agent-form-wrap,
.pq-message-card,
.pq-conversation-disabled,
.pq-edit-status-card {
  background: #ffffff;
  /* border: 1px solid #d9dee7; */
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.pq-create-card-body-Details{
 background: #f9fafb !important;
}

.pq-workflow-card,
.pq-message-card,
.pq-conversation-disabled {
  overflow: hidden;
}

.pq-create-card {
  overflow: visible;
}

.pq-create-card-body {
  padding: 20px;
}

.pq-form-group + .pq-form-group {
  margin-top: 26px;
}

.pq-form-label {
  display: block;
  margin-bottom: 9px;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 600;
  color: #111827;
}

.pq-light-text {
  color: #8b95a7;
  font-weight: 400;
}

.pq-helper-text {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #8b95a7;
}

.pq-text-input,
.pq-textarea-input,
.pq-select-like,
.pq-select-wrap select,
.pq-message-textarea,
.pq-designer-rs__control,
.pq-designer-rs__control--is-focused,
.pq-designer-group .css-13cymwt-control,
.pq-designer-group .css-t3ipsp-control {
  width: 100%;
  border: 1px solid #c8d0dc;
  border-radius: 10px;
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  box-shadow: none;
}

.pq-text-input,
.pq-select-wrap select {
  height: 44px;
  padding: 0 14px;
}

.pq-textarea-input {
  min-height: 148px;
  padding: 14px 16px;
  line-height: 1.65;
  resize: vertical;
}

.pq-message-textarea {
  min-height: 122px;
  padding: 14px 16px;
  line-height: 1.65;
  resize: vertical;
}

.pq-text-input::placeholder,
.pq-textarea-input::placeholder,
.pq-message-textarea::placeholder,
.pq-select-wrap select:invalid {
  color: #97a1b2;
}

.pq-text-input:focus,
.pq-textarea-input:focus,
.pq-select-like:focus,
.pq-select-wrap select:focus,
.pq-message-textarea:focus {
  outline: none;
  border-color: #9aa5b4;
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.18);
}

.pq-search-holder {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.pq-search-holder > div:first-child {
  width: 100%;
}

.pq-search-holder .search-brokerage-agent-team,
.pq-search-holder .search-brokerage-agent-team-wrap,
.pq-search-holder .search-brokerage-agent-team-container {
  width: 100%;
}

.pq-add-agent-btn {
  height: 42px;
  padding: 0 18px;
  border: 1px solid #bcd1fb;
  background: #eff6ff;
  color: #2563eb;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.pq-add-agent-btn-row {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
}

.pq-add-agent-btn--manager {
  color: #4f46e5;
  border-color: #c7d2fe;
  background: #eef2ff;
}

.pq-add-agent-btn--manager:hover {
  background: #e0e7ff;
  border-color: #a5b4fc;
}

.pq-add-agent-btn-row .pq-add-agent-btn {
  width: auto;
  max-width: none;
}

.pq-add-agent-btn:hover {
  background: #dbeafe;
  border-color: #93c5fd;
}

.pq-agent-card-head,
.pq-add-agent-header,
.pq-workflow-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 20px;
  /* border-bottom: 1px solid #e5e7eb; */
}

.pq-agent-card-head h3,
.pq-add-agent-title {
  margin: 0;
  font-size: 19px;
  line-height: 1.35;
  font-weight: 600;
  color: #111827;
}

.pq-add-agent-subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.45;
  color: #64748b;
}

.pq-agent-edit-btn,
.pq-add-agent-close,
.pq-upload-box-btn,
.pq-emoji-inline-btn {
  height: 36px;
  padding: 0 14px;
  border: 1px solid #c7ced8;
  border-radius: 10px;
  background: #ffffff;
  color: #334155;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
}

.pq-add-agent-close {
  width: 36px;
  padding: 0;
}

.pq-agent-grid-details,
.pq-agent-grid-compact {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  padding: 18px 20px;
}

/* .pq-k {
  margin-bottom: 6px;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 600;
  color: #64748b;
} */

.pq-v {
  font-size: 14px;
  line-height: 1.55;
  color: #111827;
  word-break: break-word;
}

.pq-add-agent-section {
  border-top: 1px solid #e5e7eb;
}

.pq-add-agent-section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  background: #ffffff;
  border-bottom: 1px solid #edf1f5;
}

.pq-add-agent-section-head .orange { color: #f97316; }
.pq-add-agent-section-head .green { color: #16a34a; }
.pq-add-agent-section-head .purple { color: #9333ea; }
.pq-add-agent-section-head .pink { color: #ec4899; }

.pq-add-agent-grid-1,
.pq-add-agent-grid-2,
.pq-add-agent-grid-3 {
  display: grid;
  gap: 18px;
  padding: 18px;
}

.pq-add-agent-grid-1 { grid-template-columns: 1fr; }
.pq-add-agent-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.pq-add-agent-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

.pq-add-agent-select-cell {
  min-width: 0;
}

.pq-add-agent-react-select {
  width: 100%;
}

.pq-add-agent-rs__control,
.pq-add-agent-rs__control--is-focused {
  width: 100%;
  min-height: 44px;
  border: 1px solid #c8d0dc;
  border-radius: 10px;
  box-shadow: none;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
}

.pq-add-agent-rs__menu {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

/* Body portaled menu — above modals/cards (overflow:hidden cannot clip it) */
.pq-add-agent-rs__menu-portal {
  z-index: 10050;
}

.pq-add-agent-rs__option {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  line-height: 1.35;
}

.pq-select-wrap {
  position: relative;
}

.pq-select-wrap i {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  pointer-events: none;
  font-size: 18px;
}

.pq-upload-box {
  border: 2px dashed #d5dbe4;
  border-radius: 14px;
  background: #f9fafb;
  text-align: center;
  padding: 48px 20px;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.pq-upload-box--drag {
  border-color: #60a5fa;
  background: #eff6ff;
}

.pq-upload-box-icon {
  font-size: 52px;
  line-height: 1;
  color: #98a2b3;
  margin-bottom: 10px;
}

.pq-upload-box-title {
  margin-bottom: 6px;
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
}

.pq-upload-box-or {
  margin-bottom: 14px;
  color: #6b7280;
  font-size: 14px;
}

.pq-upload-box-note {
  margin-top: 14px;
  font-size: 12px;
  color: #97a1b2;
}

.pq-uploaded-files {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.pq-uploaded-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #d9dee7;
  border-radius: 12px;
  background: #ffffff;
}

.pq-uploaded-file-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pq-uploaded-file-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f3f4f6;
  color: #4b5563;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-uploaded-file-name {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  word-break: break-word;
}

.pq-uploaded-file-remove {
  width: 34px;
  height: 34px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  color: #ef4444;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pq-designer-group {
  max-width: 360px;
}

.pq-designer-rs__control,
.pq-designer-rs__control--is-focused {
  min-height: 40px !important;
}

.pq-designer-rs__placeholder,
.pq-designer-rs__single-value {
  font-size: 14px;
}

.pq-message-card {
  padding: 0;
  border: 0;
  box-shadow: none;
  background: transparent;
}

.pq-message-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.pq-message-check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 14px;
  color: #1f2937;
}

.pq-message-check input {
  width: 15px;
  height: 15px;
}

.pq-conversation-scroll {
  max-height: 320px;
  overflow-y: auto;
  padding: 16px 18px;
  background: #ffffff;
}

.pq-conversation-footer-note {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
  font-size: 13px;
  color: #64748b;
  text-align: center;
}

.pq-bottom-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #e5e7eb;
}

.pq-workflow-card-head {
  padding: 16px 18px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.pq-workflow-card-body {
  padding: 18px;
}

.pq-workflow-list-wrap {
  position: relative;
}

.pq-workflow-row {
  position: relative;
  display: flex;
  gap: 12px;
  padding-bottom: 22px;
}

.pq-workflow-row:last-child {
  padding-bottom: 0;
}

.pq-workflow-left {
  position: relative;
  width: 32px;
  flex-shrink: 0;
}

.pq-workflow-line {
  position: absolute;
  left: 15px;
  top: 32px;
  bottom: -32px;
  width: 2px;
  background: #d1d5db;
}

.pq-workflow-icon {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  position: relative;
  z-index: 1;
}

.pq-workflow-icon.blue { background: #dbeafe; color: #2563eb; }
.pq-workflow-icon.purple { background: #f3e8ff; color: #9333ea; }
.pq-workflow-icon.green { background: #dcfce7; color: #16a34a; }
.pq-workflow-icon.orange { background: #ffedd5; color: #ea580c; }
.pq-workflow-icon.mint { background: #dcfce7; color: #059669; }

.pq-workflow-content {
  padding-top: 2px;
}

.pq-workflow-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
}

.pq-workflow-detail,
.pq-workflow-assigned {
  font-size: 14px;
  line-height: 1.5;
  color: #64748b;
}

.pq-workflow-assigned {
  margin-top: 2px;
}

.pq-edit-status-card {
  padding: 18px;
}

.pq-edit-status-top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.pq-edit-status-icon {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.pq-edit-status-icon.inprogress { background: #ede9fe; color: #7c3aed; }
.pq-edit-status-icon.quoted { background: #ffedd5; color: #ea580c; }
.pq-edit-status-icon.approved { background: #dcfce7; color: #16a34a; }
.pq-edit-status-icon.completed { background: #d1fae5; color: #059669; }

.pq-edit-status-badge {
  height: 30px;
  padding: 0 14px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}

.pq-edit-status-badge.inprogress { background: #cffafe; color: #0e7490; }
.pq-edit-status-badge.quoted { background: #ffedd5; color: #c2410c; }
.pq-edit-status-badge.approved { background: #d1fae5; color: #15803d; }
.pq-edit-status-badge.completed { background: #e5e7eb; color: #374151; }

.pq-edit-status-title {
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.pq-edit-status-text {
  font-size: 14px;
  color: #64748b;
}

@media (max-width: 1360px) {
  .pq-create-layout {
    grid-template-columns: minmax(0, 1fr) 400px;
  }
}

@media (max-width: 1200px) {
  .pq-create-layout {
    grid-template-columns: 1fr;
  }

  .pq-create-right {
    position: static;
    top: auto;
  }
}

@media (max-width: 768px) {
  .pq-create-header {
    flex-direction: column;
    align-items: stretch;
    padding: 18px 16px;
  }

  .pq-create-layout {
    gap: 16px;
    padding: 16px 0 24px;
  }

  .pq-create-card-body,
  .pq-workflow-card-body,
  .pq-agent-card-head,
  .pq-add-agent-header,
  .pq-workflow-card-head,
  .pq-agent-grid-details,
  .pq-agent-grid-compact,
  .pq-add-agent-grid-1,
  .pq-add-agent-grid-2,
  .pq-add-agent-grid-3 {
    padding-left: 16px;
    padding-right: 16px;
  }

  .pq-agent-grid-details,
  .pq-agent-grid-compact,
  .pq-add-agent-grid-2,
  .pq-add-agent-grid-3 {
    grid-template-columns: 1fr;
  }

  .pq-message-label-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .pq-bottom-actions {
    flex-direction: column;
  }

  .pq-footer-cancel-btn,
  .pq-footer-primary-btn,
  .pq-top-cancel-btn,
  .pq-add-agent-btn,
  .pq-designer-group {
    width: 100%;
    max-width: 100%;
  }

  .pq-add-agent-btn-row .pq-add-agent-btn {
    width: auto;
    max-width: none;
  }

  .pq-agent-change-modal {
    margin: 16px;
    width: calc(100% - 32px);
  }
}

/* Confirm agent change (modal) + in-form warning banner */
.pq-agent-change-overlay {
  position: fixed;
  inset: 0;
  z-index: 10060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(17, 24, 39, 0.52);
  backdrop-filter: blur(2px);
}

.pq-agent-change-modal {
  width: 100%;
  max-width: 480px;
  padding: 22px 26px 20px;
  border-radius: 12px;
  border: 1px solid #e7e5e4;
  background: #fff;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.06),
    0 20px 50px -12px rgba(0, 0, 0, 0.22);
  text-align: left;
}

.pq-agent-change-modal-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
}

.pq-agent-change-modal-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  margin: 0;
  border-radius: 10px;
  background: #fff7ed;
  color: #c2410c;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  line-height: 1;
}

.pq-agent-change-modal-title {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: #7c2d12;
  font-family: Georgia, "Times New Roman", ui-serif, serif;
}

.pq-agent-change-modal-body {
  margin: 0 0 22px;
  font-size: 15px;
  line-height: 1.6;
  color: #44403c;
}

.pq-agent-change-modal-body strong {
  color: #292524;
  font-weight: 700;
}

.pq-agent-change-modal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  padding-top: 4px;
  border-top: none;
}

.pq-agent-change-modal-btn {
  min-height: 40px;
  padding: 0 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
}

.pq-agent-change-modal-btn--outline {
  background: #fff;
  border-color: #d6d3d1;
  color: #57534e;
}

.pq-agent-change-modal-btn--outline:hover {
  background: #fafaf9;
  border-color: #a8a29e;
}

.pq-agent-change-modal-btn--confirm {
  background: #ea580c;
  border-color: #ea580c;
  color: #fff;
}

.pq-agent-change-modal-btn--confirm:hover {
  background: #c2410c;
  border-color: #c2410c;
}

.pq-agent-change-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid #fde68a;
  border-radius: 12px;
  background: #fffbeb;
  color: #78350f;
  font-size: 14px;
  line-height: 1.45;
}

.pq-agent-change-banner-icon {
  flex-shrink: 0;
  font-size: 22px;
  color: #d97706;
}

.pq-agent-change-banner-text {
  flex: 1 1;
  min-width: 200px;
}

.pq-agent-change-banner-cancel {
  margin-left: auto;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #d4d4d8;
  background: #fff;
  color: #52525b;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.pq-agent-change-banner-cancel:hover {
  background: #fafafa;
}
`, "",{"version":3,"sources":["webpack://./src/pages/signage/projectandquote-addedit.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;yGAgGyG;AACzG;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;;;GAQG;;AAEH;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;AACf;;AAEA;;;;;GAKG;;AAEH;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,+EAA+E;AAC/E;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,6EAA6E;AAC7E;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2FAA2F;AAC3F;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;;;;;;;;GAQG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;IAKE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uFAAuF;AACzF;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;;EASE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;;;;GAMG;;AAEH;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,qCAAqC,cAAc,EAAE;AACrD,oCAAoC,cAAc,EAAE;AACpD,qCAAqC,cAAc,EAAE;AACrD,mCAAmC,cAAc,EAAE;;AAEnD;;;EAGE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA,uBAAuB,0BAA0B,EAAE;AACnD,uBAAuB,gDAAgD,EAAE;AACzE,uBAAuB,gDAAgD,EAAE;;AAEzE;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,6EAA6E;AAC7E;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;;AAEtE;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;AACtE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;;AAEvE;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,oBAAoB;EACtB;;EAEA;;;;;;;;;;IAUE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;IAKE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;AACF;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB;;yCAEuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* .pq-create-page {\n  background: #f8fafc;\n  min-height: 100vh;\n  padding: 0;\n  color: #0f172a;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.pq-create-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 18px;\n  margin-bottom: 0;\n  padding: 22px 24px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n}\n\n.pq-create-title {\n  margin: 0;\n  font-size: 18px;\n  line-height: 1.35;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.pq-create-subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pq-top-cancel-btn,\n.pq-footer-cancel-btn {\n  height: 40px;\n  padding: 0 18px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #1e293b;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-top-cancel-btn:hover,\n.pq-footer-cancel-btn:hover {\n  background: #f8fafc;\n}\n\n.pq-footer-primary-btn {\n  height: 42px;\n  padding: 0 20px;\n  border: 0;\n  background: #2563eb;\n  color: #fff;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-footer-primary-btn:hover {\n  background: #1d4ed8;\n}\n\n.pq-footer-primary-btn:disabled,\n.pq-top-cancel-btn:disabled,\n.pq-footer-cancel-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.pq-create-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 18px;\n  align-items: start;\n  padding: 16px 18px 24px;\n}\n\n.pq-create-left,\n.pq-create-right {\n  min-width: 0;\n}\n\n.pq-create-card,\n.pq-workflow-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n}\n\n/* Allow react-select menus (Assign Designer) to extend past the card edge; workflow card stays clipped */\n.pq-workflow-card {\n  overflow: hidden;\n}\n\n.pq-create-card {\n  overflow: visible;\n}\n\n.pq-create-card-body {\n  padding: 22px;\n}\n\n.pq-form-group + .pq-form-group {\n  margin-top: 22px;\n}\n\n.pq-form-label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-light-text {\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.pq-helper-text {\n  margin: 8px 0 0;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.pq-text-input,\n.pq-textarea-input,\n.pq-select-like,\n.pq-designer-group .css-13cymwt-control,\n.pq-designer-group .css-t3ipsp-control {\n  width: 100%;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #fff;\n  color: #111827;\n  font-size: 14px;\n}\n\n.pq-text-input {\n  height: 42px;\n  padding: 0 14px;\n}\n\n.pq-textarea-input {\n  min-height: 140px;\n  padding: 14px 16px;\n  resize: vertical;\n  line-height: 1.6;\n}\n\n.pq-text-input::placeholder,\n.pq-textarea-input::placeholder {\n  color: #94a3b8;\n}\n\n.pq-text-input:focus,\n.pq-textarea-input:focus,\n.pq-select-like:focus {\n  outline: none;\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);\n}\n\n.pq-search-holder {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.pq-add-agent-btn {\n  height: 42px;\n  padding: 0 16px;\n  border: 1px solid #dbeafe;\n  background: #eff6ff;\n  color: #1d4ed8;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.pq-add-agent-btn:hover {\n  background: #dbeafe;\n}\n\n.pq-agent-details-card,\n.pq-add-agent-form-wrap {\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  background: #fff;\n  overflow: hidden;\n}\n\n/* Address autocomplete dropdown must escape card clipping. */\n.pq-add-agent-form-wrap {\n  overflow: visible;\n}\n\n/* Inline team member form inside project create (not a modal) */\n.brokerage-teammember-creation-inline {\n  width: 100%;\n  padding: 0 18px 18px;\n}\n\n.brokerage-teammember-creation-inline .content.container {\n  max-width: none;\n  padding: 0;\n}\n\n.brokerage-teammember-creation-embedded {\n  padding: 1rem 1.25rem 1.5rem;\n}\n\n.pq-address-autocomplete-menu {\n  z-index: 2147483647 !important;\n}\n\n/* .pq-agent-card-head,\n.pq-add-agent-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px;\n  border-bottom: 1px solid #e5e7eb;\n} */\n\n.pq-agent-card-head h3,\n.pq-add-agent-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.pq-add-agent-subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pq-agent-edit-btn,\n.pq-add-agent-close {\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.pq-add-agent-close {\n  width: 40px;\n  justify-content: center;\n  padding: 0;\n}\n\n.pq-agent-grid-details,\n.pq-agent-grid-compact {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  padding: 18px;\n}\n\n/* .pq-k {\n  font-size: 12px;\n  font-weight: 700;\n  color: #64748b;\n  margin-bottom: 6px;\n} */\n\n.pq-v {\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.6;\n  word-break: break-word;\n}\n\n.pq-add-agent-section {\n  border-top: 1px solid #e5e7eb;\n}\n\n.pq-add-agent-section-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #334155;\n}\n\n.pq-add-agent-section-head .orange {\n  color: #f97316;\n}\n\n.pq-add-agent-section-head .green {\n  color: #22c55e;\n}\n\n.pq-add-agent-section-head .purple {\n  color: #a855f7;\n}\n\n.pq-add-agent-section-head .pink {\n  color: #ec4899;\n}\n\n.pq-add-agent-grid-1,\n.pq-add-agent-grid-2,\n.pq-add-agent-grid-3 {\n  display: grid;\n  gap: 18px;\n  padding: 0 18px 18px;\n}\n\n.pq-add-agent-grid-1 {\n  grid-template-columns: 1fr;\n}\n\n.pq-add-agent-grid-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.pq-add-agent-grid-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n/* Add-agent flow: react-select menu stays column width; long firm names wrap */\n.pq-add-agent-select-cell {\n  min-width: 0;\n}\n\n.pq-add-agent-react-select {\n  width: 100%;\n}\n\n.pq-add-agent-rs__control,\n.pq-add-agent-rs__control--is-focused {\n  width: 100%;\n  min-height: 44px;\n  border: 1px solid #c8d0dc;\n  border-radius: 10px;\n  box-shadow: none;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n}\n\n.pq-add-agent-rs__menu {\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n}\n\n/* Body portaled menu — above modals/cards (overflow:hidden cannot clip it) */\n.pq-add-agent-rs__menu-portal {\n  z-index: 10050;\n}\n\n.pq-add-agent-rs__option {\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n  line-height: 1.35;\n}\n\n.pq-select-wrap {\n  position: relative;\n}\n\n.pq-select-wrap select {\n  appearance: none;\n  width: 100%;\n  height: 42px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #fff;\n  color: #111827;\n  padding: 0 40px 0 14px;\n  font-size: 14px;\n}\n\n.pq-select-wrap i {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #64748b;\n  pointer-events: none;\n}\n\n.pq-upload-box {\n  border: 2px dashed #d1d5db;\n  border-radius: 14px;\n  background: #f8fafc;\n  text-align: center;\n  padding: 42px 20px;\n  transition: 0.2s ease;\n}\n\n.pq-upload-box--drag {\n  border-color: #60a5fa;\n  background: #eff6ff;\n}\n\n.pq-upload-box-icon {\n  font-size: 46px;\n  color: #9ca3af;\n  margin-bottom: 10px;\n}\n\n.pq-upload-box-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: #334155;\n  margin-bottom: 4px;\n}\n\n.pq-upload-box-or {\n  color: #94a3b8;\n  font-size: 14px;\n  margin-bottom: 14px;\n}\n\n.pq-upload-box-btn {\n  height: 38px;\n  padding: 0 16px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #fff;\n  color: #1e293b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-upload-box-note {\n  margin-top: 12px;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.pq-uploaded-files {\n  display: grid;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.pq-uploaded-file {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.pq-uploaded-file-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pq-uploaded-file-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: #f1f5f9;\n  color: #475569;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-uploaded-file-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.pq-uploaded-file-remove {\n  width: 34px;\n  height: 34px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fff;\n  color: #ef4444;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.pq-designer-group {\n  position: relative;\n  z-index: 40;\n  max-width: 340px;\n}\n\n.pq-designer-rs__menu {\n  z-index: 50;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n}\n\n.pq-message-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: visible;\n  background: #fff;\n}\n\n.pq-message-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.pq-emoji-inline-btn {\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pq-message-emoji-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* Portaled to document.body — fixed so it floats over the textarea (not in layout flow). */\n.pq-message-emoji-pop {\n  position: fixed;\n  z-index: 10050;\n  min-width: 280px;\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.14);\n}\n\n.pq-message-emoji-grid {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 4px;\n}\n\n.pq-message-emoji-item {\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  font-size: 22px;\n  line-height: 1.2;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: 1;\n  transition: background 0.12s ease;\n}\n\n.pq-message-emoji-item:hover {\n  background: #f1f5f9;\n}\n\n.pq-message-textarea {\n  width: 100%;\n  min-height: 110px;\n  padding: 14px 16px;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  resize: vertical;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.pq-message-check {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 12px;\n  font-size: 14px;\n  color: #334155;\n}\n\n.pq-conversation-disabled {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.pq-conversation-scroll {\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 14px;\n  background: #fff;\n}\n\n.pq-conversation-footer-note {\n  padding: 14px;\n  border-top: 1px solid #e5e7eb;\n  background: #f8fafc;\n  font-size: 13px;\n  color: #64748b;\n  text-align: center;\n}\n\n.pq-bottom-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 18px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.pq-workflow-card-head {\n  padding: 16px 18px;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-workflow-card-body {\n  padding: 18px;\n}\n\n.pq-workflow-list-wrap {\n  position: relative;\n}\n\n.pq-workflow-row {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  padding-bottom: 22px;\n}\n\n.pq-workflow-left {\n  position: relative;\n  width: 32px;\n  flex-shrink: 0;\n}\n/* \n.pq-workflow-line {\n  position: absolute;\n  left: 15px;\n  top: 34px;\n  bottom: -10px;\n  width: 2px;\n  background: #d1d5db;\n} */\n\n.pq-workflow-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  position: relative;\n  z-index: 1;\n}\n\n.pq-workflow-icon.blue {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.pq-workflow-icon.purple {\n  background: #f3e8ff;\n  color: #9333ea;\n}\n\n.pq-workflow-icon.green {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.pq-workflow-icon.orange {\n  background: #ffedd5;\n  color: #ea580c;\n}\n\n.pq-workflow-icon.mint {\n  background: #dcfce7;\n  color: #059669;\n}\n\n.pq-workflow-content {\n  padding-top: 2px;\n}\n\n.pq-workflow-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\n.pq-workflow-detail,\n.pq-workflow-assigned {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.pq-edit-status-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  padding: 16px 18px;\n}\n\n.pq-edit-status-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.pq-edit-status-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  background: #dcfce7;\n  color: #059669;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n\n.pq-edit-status-icon.inprogress {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.pq-edit-status-icon.quoted {\n  background: #ffedd5;\n  color: #ea580c;\n}\n\n.pq-edit-status-icon.approved {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.pq-edit-status-icon.completed {\n  background: #d1fae5;\n  color: #059669;\n}\n\n.pq-edit-status-badge {\n  height: 30px;\n  padding: 0 14px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #4b5563;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n}\n\n.pq-edit-status-badge.inprogress {\n  background: #cffafe;\n  color: #0e7490;\n}\n\n.pq-edit-status-badge.quoted {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.pq-edit-status-badge.approved {\n  background: #d1fae5;\n  color: #15803d;\n}\n\n.pq-edit-status-badge.completed {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.pq-edit-status-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\n.pq-edit-status-text {\n  font-size: 14px;\n  color: #64748b;\n}\n\n@media (max-width: 1200px) {\n  .pq-create-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .pq-create-header {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 18px;\n  }\n\n  .pq-create-layout {\n    padding: 14px 0 20px;\n  }\n\n  .pq-create-card-body,\n  .pq-workflow-card-body {\n    padding: 18px;\n  }\n\n  .pq-agent-grid-details,\n  .pq-agent-grid-compact,\n  .pq-add-agent-grid-2,\n  .pq-add-agent-grid-3 {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-message-label-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .pq-bottom-actions {\n    flex-direction: column;\n  }\n\n  .pq-footer-cancel-btn,\n  .pq-footer-primary-btn,\n  .pq-top-cancel-btn,\n  .pq-text-input,\n  .pq-designer-group {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .pq-add-agent-title {\n    font-size: 28px;\n  }\n}\n\n.search-bat-card{\n  margin-bottom: 21px;\n}\n\n.pq-create-page {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 clamp(16px, 3vw, 40px) 28px;\n  min-height: 100vh;\n  /* background: #f3f4f6; */\n  color: #111827;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.pq-create-page *,\n.pq-create-page *::before,\n.pq-create-page *::after {\n  box-sizing: border-box;\n}\n\n.pq-create-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 24px;\n  background: #ffffff;\n  border-bottom: 1px solid #d9dee7;\n}\n\n.pq-create-title {\n  margin: 0;\n  font-size: 18px;\n  line-height: 1.35;\n  font-weight: 500;\n  color: #111827;\n}\n\n.pq-create-subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #4b5563;\n}\n\n.pq-top-cancel-btn,\n.pq-footer-cancel-btn {\n  min-width: 88px;\n  height: 40px;\n  padding: 0 18px;\n  border: 1px solid #c7ced8;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pq-top-cancel-btn:hover,\n.pq-footer-cancel-btn:hover {\n  background: #f9fafb;\n  border-color: #b6c0cd;\n}\n\n.pq-footer-primary-btn {\n  min-width: 136px;\n  height: 40px;\n  padding: 0 20px;\n  border: 1px solid #2563eb;\n  border-radius: 10px;\n  background: #2563eb;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pq-footer-primary-btn:hover {\n  background: #1d4ed8;\n}\n\n.pq-footer-primary-btn:disabled,\n.pq-top-cancel-btn:disabled,\n.pq-footer-cancel-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.pq-create-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 510px;\n  gap: 24px;\n  align-items: start;\n  padding: 24px 0 28px;\n}\n\n.pq-create-left,\n.pq-create-right {\n  min-width: 0;\n}\n\n.pq-create-right {\n  position: sticky;\n  top: 24px;\n  align-self: start;\n}\n\n.pq-create-card,\n.pq-workflow-card,\n.pq-agent-details-card,\n.pq-add-agent-form-wrap,\n.pq-message-card,\n.pq-conversation-disabled,\n.pq-edit-status-card {\n  background: #ffffff;\n  /* border: 1px solid #d9dee7; */\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.pq-create-card-body-Details{\n background: #f9fafb !important;\n}\n\n.pq-workflow-card,\n.pq-message-card,\n.pq-conversation-disabled {\n  overflow: hidden;\n}\n\n.pq-create-card {\n  overflow: visible;\n}\n\n.pq-create-card-body {\n  padding: 20px;\n}\n\n.pq-form-group + .pq-form-group {\n  margin-top: 26px;\n}\n\n.pq-form-label {\n  display: block;\n  margin-bottom: 9px;\n  font-size: 13px;\n  line-height: 1.35;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-light-text {\n  color: #8b95a7;\n  font-weight: 400;\n}\n\n.pq-helper-text {\n  margin: 8px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #8b95a7;\n}\n\n.pq-text-input,\n.pq-textarea-input,\n.pq-select-like,\n.pq-select-wrap select,\n.pq-message-textarea,\n.pq-designer-rs__control,\n.pq-designer-rs__control--is-focused,\n.pq-designer-group .css-13cymwt-control,\n.pq-designer-group .css-t3ipsp-control {\n  width: 100%;\n  border: 1px solid #c8d0dc;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #111827;\n  font-size: 14px;\n  font-family: \"Roboto\", sans-serif;\n  box-shadow: none;\n}\n\n.pq-text-input,\n.pq-select-wrap select {\n  height: 44px;\n  padding: 0 14px;\n}\n\n.pq-textarea-input {\n  min-height: 148px;\n  padding: 14px 16px;\n  line-height: 1.65;\n  resize: vertical;\n}\n\n.pq-message-textarea {\n  min-height: 122px;\n  padding: 14px 16px;\n  line-height: 1.65;\n  resize: vertical;\n}\n\n.pq-text-input::placeholder,\n.pq-textarea-input::placeholder,\n.pq-message-textarea::placeholder,\n.pq-select-wrap select:invalid {\n  color: #97a1b2;\n}\n\n.pq-text-input:focus,\n.pq-textarea-input:focus,\n.pq-select-like:focus,\n.pq-select-wrap select:focus,\n.pq-message-textarea:focus {\n  outline: none;\n  border-color: #9aa5b4;\n  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.18);\n}\n\n.pq-search-holder {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.pq-search-holder > div:first-child {\n  width: 100%;\n}\n\n.pq-search-holder .search-brokerage-agent-team,\n.pq-search-holder .search-brokerage-agent-team-wrap,\n.pq-search-holder .search-brokerage-agent-team-container {\n  width: 100%;\n}\n\n.pq-add-agent-btn {\n  height: 42px;\n  padding: 0 18px;\n  border: 1px solid #bcd1fb;\n  background: #eff6ff;\n  color: #2563eb;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.pq-add-agent-btn-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.pq-add-agent-btn--manager {\n  color: #4f46e5;\n  border-color: #c7d2fe;\n  background: #eef2ff;\n}\n\n.pq-add-agent-btn--manager:hover {\n  background: #e0e7ff;\n  border-color: #a5b4fc;\n}\n\n.pq-add-agent-btn-row .pq-add-agent-btn {\n  width: auto;\n  max-width: none;\n}\n\n.pq-add-agent-btn:hover {\n  background: #dbeafe;\n  border-color: #93c5fd;\n}\n\n.pq-agent-card-head,\n.pq-add-agent-header,\n.pq-workflow-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 0px 20px;\n  /* border-bottom: 1px solid #e5e7eb; */\n}\n\n.pq-agent-card-head h3,\n.pq-add-agent-title {\n  margin: 0;\n  font-size: 19px;\n  line-height: 1.35;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-add-agent-subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #64748b;\n}\n\n.pq-agent-edit-btn,\n.pq-add-agent-close,\n.pq-upload-box-btn,\n.pq-emoji-inline-btn {\n  height: 36px;\n  padding: 0 14px;\n  border: 1px solid #c7ced8;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.pq-add-agent-close {\n  width: 36px;\n  padding: 0;\n}\n\n.pq-agent-grid-details,\n.pq-agent-grid-compact {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  padding: 18px 20px;\n}\n\n/* .pq-k {\n  margin-bottom: 6px;\n  font-size: 12px;\n  line-height: 1.35;\n  font-weight: 600;\n  color: #64748b;\n} */\n\n.pq-v {\n  font-size: 14px;\n  line-height: 1.55;\n  color: #111827;\n  word-break: break-word;\n}\n\n.pq-add-agent-section {\n  border-top: 1px solid #e5e7eb;\n}\n\n.pq-add-agent-section-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1f2937;\n  background: #ffffff;\n  border-bottom: 1px solid #edf1f5;\n}\n\n.pq-add-agent-section-head .orange { color: #f97316; }\n.pq-add-agent-section-head .green { color: #16a34a; }\n.pq-add-agent-section-head .purple { color: #9333ea; }\n.pq-add-agent-section-head .pink { color: #ec4899; }\n\n.pq-add-agent-grid-1,\n.pq-add-agent-grid-2,\n.pq-add-agent-grid-3 {\n  display: grid;\n  gap: 18px;\n  padding: 18px;\n}\n\n.pq-add-agent-grid-1 { grid-template-columns: 1fr; }\n.pq-add-agent-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.pq-add-agent-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n\n.pq-add-agent-select-cell {\n  min-width: 0;\n}\n\n.pq-add-agent-react-select {\n  width: 100%;\n}\n\n.pq-add-agent-rs__control,\n.pq-add-agent-rs__control--is-focused {\n  width: 100%;\n  min-height: 44px;\n  border: 1px solid #c8d0dc;\n  border-radius: 10px;\n  box-shadow: none;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n}\n\n.pq-add-agent-rs__menu {\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n}\n\n/* Body portaled menu — above modals/cards (overflow:hidden cannot clip it) */\n.pq-add-agent-rs__menu-portal {\n  z-index: 10050;\n}\n\n.pq-add-agent-rs__option {\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n  line-height: 1.35;\n}\n\n.pq-select-wrap {\n  position: relative;\n}\n\n.pq-select-wrap i {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #64748b;\n  pointer-events: none;\n  font-size: 18px;\n}\n\n.pq-upload-box {\n  border: 2px dashed #d5dbe4;\n  border-radius: 14px;\n  background: #f9fafb;\n  text-align: center;\n  padding: 48px 20px;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.pq-upload-box--drag {\n  border-color: #60a5fa;\n  background: #eff6ff;\n}\n\n.pq-upload-box-icon {\n  font-size: 52px;\n  line-height: 1;\n  color: #98a2b3;\n  margin-bottom: 10px;\n}\n\n.pq-upload-box-title {\n  margin-bottom: 6px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.pq-upload-box-or {\n  margin-bottom: 14px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.pq-upload-box-note {\n  margin-top: 14px;\n  font-size: 12px;\n  color: #97a1b2;\n}\n\n.pq-uploaded-files {\n  display: grid;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.pq-uploaded-file {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid #d9dee7;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.pq-uploaded-file-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pq-uploaded-file-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: #f3f4f6;\n  color: #4b5563;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-uploaded-file-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  word-break: break-word;\n}\n\n.pq-uploaded-file-remove {\n  width: 34px;\n  height: 34px;\n  border: 1px solid #d9dee7;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #ef4444;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.pq-designer-group {\n  max-width: 360px;\n}\n\n.pq-designer-rs__control,\n.pq-designer-rs__control--is-focused {\n  min-height: 40px !important;\n}\n\n.pq-designer-rs__placeholder,\n.pq-designer-rs__single-value {\n  font-size: 14px;\n}\n\n.pq-message-card {\n  padding: 0;\n  border: 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.pq-message-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.pq-message-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.pq-message-check input {\n  width: 15px;\n  height: 15px;\n}\n\n.pq-conversation-scroll {\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 16px 18px;\n  background: #ffffff;\n}\n\n.pq-conversation-footer-note {\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n  background: #f9fafb;\n  font-size: 13px;\n  color: #64748b;\n  text-align: center;\n}\n\n.pq-bottom-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 22px;\n  padding-top: 18px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.pq-workflow-card-head {\n  padding: 16px 18px;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-workflow-card-body {\n  padding: 18px;\n}\n\n.pq-workflow-list-wrap {\n  position: relative;\n}\n\n.pq-workflow-row {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  padding-bottom: 22px;\n}\n\n.pq-workflow-row:last-child {\n  padding-bottom: 0;\n}\n\n.pq-workflow-left {\n  position: relative;\n  width: 32px;\n  flex-shrink: 0;\n}\n\n.pq-workflow-line {\n  position: absolute;\n  left: 15px;\n  top: 32px;\n  bottom: -32px;\n  width: 2px;\n  background: #d1d5db;\n}\n\n.pq-workflow-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  position: relative;\n  z-index: 1;\n}\n\n.pq-workflow-icon.blue { background: #dbeafe; color: #2563eb; }\n.pq-workflow-icon.purple { background: #f3e8ff; color: #9333ea; }\n.pq-workflow-icon.green { background: #dcfce7; color: #16a34a; }\n.pq-workflow-icon.orange { background: #ffedd5; color: #ea580c; }\n.pq-workflow-icon.mint { background: #dcfce7; color: #059669; }\n\n.pq-workflow-content {\n  padding-top: 2px;\n}\n\n.pq-workflow-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\n.pq-workflow-detail,\n.pq-workflow-assigned {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.pq-workflow-assigned {\n  margin-top: 2px;\n}\n\n.pq-edit-status-card {\n  padding: 18px;\n}\n\n.pq-edit-status-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.pq-edit-status-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n\n.pq-edit-status-icon.inprogress { background: #ede9fe; color: #7c3aed; }\n.pq-edit-status-icon.quoted { background: #ffedd5; color: #ea580c; }\n.pq-edit-status-icon.approved { background: #dcfce7; color: #16a34a; }\n.pq-edit-status-icon.completed { background: #d1fae5; color: #059669; }\n\n.pq-edit-status-badge {\n  height: 30px;\n  padding: 0 14px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #4b5563;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n}\n\n.pq-edit-status-badge.inprogress { background: #cffafe; color: #0e7490; }\n.pq-edit-status-badge.quoted { background: #ffedd5; color: #c2410c; }\n.pq-edit-status-badge.approved { background: #d1fae5; color: #15803d; }\n.pq-edit-status-badge.completed { background: #e5e7eb; color: #374151; }\n\n.pq-edit-status-title {\n  margin-bottom: 4px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-edit-status-text {\n  font-size: 14px;\n  color: #64748b;\n}\n\n@media (max-width: 1360px) {\n  .pq-create-layout {\n    grid-template-columns: minmax(0, 1fr) 400px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .pq-create-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-create-right {\n    position: static;\n    top: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .pq-create-header {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 18px 16px;\n  }\n\n  .pq-create-layout {\n    gap: 16px;\n    padding: 16px 0 24px;\n  }\n\n  .pq-create-card-body,\n  .pq-workflow-card-body,\n  .pq-agent-card-head,\n  .pq-add-agent-header,\n  .pq-workflow-card-head,\n  .pq-agent-grid-details,\n  .pq-agent-grid-compact,\n  .pq-add-agent-grid-1,\n  .pq-add-agent-grid-2,\n  .pq-add-agent-grid-3 {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .pq-agent-grid-details,\n  .pq-agent-grid-compact,\n  .pq-add-agent-grid-2,\n  .pq-add-agent-grid-3 {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-message-label-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .pq-bottom-actions {\n    flex-direction: column;\n  }\n\n  .pq-footer-cancel-btn,\n  .pq-footer-primary-btn,\n  .pq-top-cancel-btn,\n  .pq-add-agent-btn,\n  .pq-designer-group {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .pq-add-agent-btn-row .pq-add-agent-btn {\n    width: auto;\n    max-width: none;\n  }\n\n  .pq-agent-change-modal {\n    margin: 16px;\n    width: calc(100% - 32px);\n  }\n}\n\n/* Confirm agent change (modal) + in-form warning banner */\n.pq-agent-change-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10060;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(17, 24, 39, 0.52);\n  backdrop-filter: blur(2px);\n}\n\n.pq-agent-change-modal {\n  width: 100%;\n  max-width: 480px;\n  padding: 22px 26px 20px;\n  border-radius: 12px;\n  border: 1px solid #e7e5e4;\n  background: #fff;\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.06),\n    0 20px 50px -12px rgba(0, 0, 0, 0.22);\n  text-align: left;\n}\n\n.pq-agent-change-modal-head {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.pq-agent-change-modal-icon {\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  margin: 0;\n  border-radius: 10px;\n  background: #fff7ed;\n  color: #c2410c;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  line-height: 1;\n}\n\n.pq-agent-change-modal-title {\n  margin: 0;\n  font-size: 19px;\n  font-weight: 700;\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n  color: #7c2d12;\n  font-family: Georgia, \"Times New Roman\", ui-serif, serif;\n}\n\n.pq-agent-change-modal-body {\n  margin: 0 0 22px;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #44403c;\n}\n\n.pq-agent-change-modal-body strong {\n  color: #292524;\n  font-weight: 700;\n}\n\n.pq-agent-change-modal-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: flex-end;\n  align-items: center;\n  padding-top: 4px;\n  border-top: none;\n}\n\n.pq-agent-change-modal-btn {\n  min-height: 40px;\n  padding: 0 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.pq-agent-change-modal-btn--outline {\n  background: #fff;\n  border-color: #d6d3d1;\n  color: #57534e;\n}\n\n.pq-agent-change-modal-btn--outline:hover {\n  background: #fafaf9;\n  border-color: #a8a29e;\n}\n\n.pq-agent-change-modal-btn--confirm {\n  background: #ea580c;\n  border-color: #ea580c;\n  color: #fff;\n}\n\n.pq-agent-change-modal-btn--confirm:hover {\n  background: #c2410c;\n  border-color: #c2410c;\n}\n\n.pq-agent-change-banner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n  padding: 12px 14px;\n  border: 1px solid #fde68a;\n  border-radius: 12px;\n  background: #fffbeb;\n  color: #78350f;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.pq-agent-change-banner-icon {\n  flex-shrink: 0;\n  font-size: 22px;\n  color: #d97706;\n}\n\n.pq-agent-change-banner-text {\n  flex: 1;\n  min-width: 200px;\n}\n\n.pq-agent-change-banner-cancel {\n  margin-left: auto;\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid #d4d4d8;\n  background: #fff;\n  color: #52525b;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-agent-change-banner-cancel:hover {\n  background: #fafafa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
